/* Rest Religion products page (rr-pp). Plan: docs/products-page-plan.md.
   - anchors: every "SHOP RETINAL SERUM" / "Shop Now" button scrolls to the selector (P5)
   - query passthrough: UTMs + click IDs from the quiz ride to checkout as cart attributes (P10)
   - dataLayer events: product_page_viewed, product_viewed, product_selected, checkout_click, product_added_to_cart (P9);
     product_page_viewed and checkout_click also go to Shopify.analytics.publish as moby_product_viewed / moby_product_added_to_cart
   Selector / FAQ behaviour is added with their sections. */
(function () {
  'use strict';

  // Query-string keys forwarded to the Shopify order as cart attributes. One list, one place (P10).
  var FORWARDED_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'clickid', 'click_id', 'transaction_id', 'aff_id', 'offer_id', 'sub1', 'sub2', 'sub3', 'sub4', 'sub5',
    'gclid', 'fbclid', 'ttclid'
  ];

  var params = new URLSearchParams(window.location.search);

  function forwardedAttributes() {
    var out = {};
    FORWARDED_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = value;
    });
    return out;
  }

  function quizState() {
    return {
      quiz_completed: params.get('quiz_completed') || '',
      won_discount: params.get('won_discount') || '',
      exit_step: params.get('exit_step') || ''
    };
  }

  // Mobybots (30 Oct): two events are also published on Shopify's web-pixel bus, as a backup for their custom pixel.
  var PIXEL_EVENTS = { product_page_viewed: 'moby_product_viewed', checkout_click: 'moby_product_added_to_cart' };

  // Shopify.analytics.publish arrives asynchronously (measured: sometimes after DOMContentLoaded), so events wait in a
  // queue that flushes as soon as it exists (50ms poll, gives up after 10s).
  var pixelQueue = [];
  var pixelTimer = null;

  function flushPixel() {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return false;
    while (pixelQueue.length) {
      var item = pixelQueue.shift();
      analytics.publish(item[0], item[1]);
    }
    return true;
  }

  function publishPixel(event, data) {
    var name = PIXEL_EVENTS[event];
    if (!name) return;
    pixelQueue.push([name, data]);
    if (flushPixel() || pixelTimer) return;
    var tries = 0;
    pixelTimer = setInterval(function () {
      if (flushPixel() || ++tries >= 200) {
        clearInterval(pixelTimer);
        pixelTimer = null;
      }
    }, 50);
  }

  function push(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = Object.assign({ event: event }, quizState(), payload || {});
    var copy = Object.assign({}, data); // GTM stamps its own ids onto the pushed object; the pixel gets the clean one
    window.dataLayer.push(data);
    publishPixel(event, copy);
  }

  window.rrpp = { forwardedAttributes: forwardedAttributes, quizState: quizState, push: push };

  document.addEventListener('DOMContentLoaded', function () {
    push('product_page_viewed');
  });
})();
